/**
 * Defines the kind of connection point for node rewards
 */
export enum RewardGraphConnectionPointTypes {
    /** Boolean */
    Boolean = 0x0001,
    /** Float */
    Float = 0x0002,
    /** Vector3 */
    Vector3 = 0x0008,
    /** Quat */
    Quat = 0x0010,
    /** Part ID */
    PartID = 0x0020,
    /** Detect type based on connection */
    AutoDetect = 0x0400,
    /** Output type that will be defined by input type */
    BasedOnInput = 0x0800,
    /** Undefined */
    Undefined = 0x1000,
    /** Bitmask of all types */
    All = 0x0fff,
}
